<template>
  <v-timeline dense>
    <v-timeline-item
      v-for="(item, i) in items"
      :key="i"
      :color="item.color"
      :icon="item.icon"
      fill-dot
    >
      <v-card :color="item.color" dark>
        <v-card-text class="pa-1 pl-3 white--text" style="font-size:0.9rem;">{{item.text}}</v-card-text>        
      </v-card>
    </v-timeline-item>
  </v-timeline>
</template>
<script>
export default {
  data: () => ({
    items: [
      {
        color: "grey darken-2",
        icon: "mdi-card-account-details",
        text: "Photo to be ready for uploading"
      },
      {
        color: "grey darken-2",
        icon: "mdi-new-box",
        text: "Click on new application"
      },
      {
        color: "grey darken-2",
        icon: "mdi-text-box-check",
        text: "Fill in all required fields"
      },
      {
        color: "grey darken-2",
        icon: "mdi-content-save-move",
        text:"Review & Submit application"
      },
      {
        color: "grey darken-2",
        icon: "mdi-check-decagram",
        text:"Await approval"
      },
      {
        color: "grey darken-2",
        icon: "mdi-badge-account",
        text:"Collect accreditation card"
      },
    ],
  }),
};
</script>